import type { Skill } from '../types';

export const skills: Skill[] = [
  // Frontend
  {
    id: 'react',
    name: 'React.js',
    category: 'frontend',
    icon: 'Code',
    level: 'expert',
  },
  {
    id: 'nextjs',
    name: 'Next.js',
    category: 'frontend',
    icon: 'Globe',
    level: 'advanced',
  },
  {
    id: 'typescript',
    name: 'TypeScript',
    category: 'frontend',
    icon: 'FileCode',
    level: 'advanced',
  },
  {
    id: 'javascript',
    name: 'JavaScript',
    category: 'frontend',
    icon: 'FileCode',
    level: 'expert',
  },
  {
    id: 'html',
    name: 'HTML',
    category: 'frontend',
    icon: 'Code',
    level: 'expert',
  },
  {
    id: 'css',
    name: 'CSS',
    category: 'frontend',
    icon: 'Palette',
    level: 'expert',
  },
  {
    id: 'tailwind',
    name: 'Tailwind CSS',
    category: 'frontend',
    icon: 'Palette',
    level: 'advanced',
  },
  {
    id: 'bootstrap',
    name: 'Bootstrap',
    category: 'frontend',
    icon: 'Grid',
    level: 'advanced',
  },
  {
    id: 'material-ui',
    name: 'Material UI',
    category: 'frontend',
    icon: 'Box',
    level: 'advanced',
  },
  {
    id: 'ant-design',
    name: 'Ant Design',
    category: 'frontend',
    icon: 'Box',
    level: 'advanced',
  },
  {
    id: 'scss',
    name: 'SCSS',
    category: 'frontend',
    icon: 'Palette',
    level: 'intermediate',
  },
  {
    id: 'jquery',
    name: 'jQuery',
    category: 'frontend',
    icon: 'Code',
    level: 'intermediate',
  },
  {
    id: 'threejs',
    name: 'Three.js',
    category: 'frontend',
    icon: 'Cube',
    level: 'intermediate',
  },

  // Backend & State Management
  {
    id: 'nodejs',
    name: 'Node.js',
    category: 'backend',
    icon: 'Server',
    level: 'intermediate',
  },
  {
    id: 'redux',
    name: 'Redux Toolkit',
    category: 'backend',
    icon: 'Database',
    level: 'advanced',
  },
  {
    id: 'redux-thunk',
    name: 'Redux Thunk',
    category: 'backend',
    icon: 'Database',
    level: 'advanced',
  },
  {
    id: 'redux-saga',
    name: 'Redux Saga',
    category: 'backend',
    icon: 'Database',
    level: 'intermediate',
  },
  {
    id: 'context-api',
    name: 'Context API',
    category: 'backend',
    icon: 'Database',
    level: 'advanced',
  },
  {
    id: 'mongodb',
    name: 'MongoDB',
    category: 'backend',
    icon: 'Database',
    level: 'intermediate',
  },

  // Tools & APIs
  {
    id: 'rest-api',
    name: 'REST APIs',
    category: 'tools',
    icon: 'Globe',
    level: 'advanced',
  },
  {
    id: 'graphql',
    name: 'GraphQL',
    category: 'tools',
    icon: 'Globe',
    level: 'intermediate',
  },
  {
    id: 'axios',
    name: 'Axios',
    category: 'tools',
    icon: 'Globe',
    level: 'advanced',
  },
  {
    id: 'socket-io',
    name: 'Socket.io',
    category: 'tools',
    icon: 'Wifi',
    level: 'intermediate',
  },
  {
    id: 'shopify-api',
    name: 'Shopify API',
    category: 'tools',
    icon: 'ShoppingCart',
    level: 'intermediate',
  },
  {
    id: 'google-calendar',
    name: 'Google Calendar API',
    category: 'tools',
    icon: 'Calendar',
    level: 'intermediate',
  },
  {
    id: 'lodash',
    name: 'Lodash',
    category: 'tools',
    icon: 'Tool',
    level: 'intermediate',
  },
  {
    id: 'vite',
    name: 'Vite',
    category: 'tools',
    icon: 'Zap',
    level: 'advanced',
  },
];
